import { FC } from "react";
import { Box, Typography } from "@mui/material";
import { headerHeight } from "../../../NavBars/Header/hardCodeData";
import { useTranslation } from "react-i18next";
import { createTranslatedOption } from "../../../utils/translationHelpers";
import DownloadPdfButton from "./DownloadPdfButton";

interface props {
  firstContent:
    | {
        img: string;
        img_mob: string;
        data: (
          | {
              option: number;
              type: string;
              description: string;
            }
          | {
              option: string;
              type: string;
              description: string;
            }
        )[];
      }
    | undefined;
  pdfFileName?: string | null;
  carId?: number;
}

const FirstContent: FC<props> = ({ firstContent, pdfFileName, carId }) => {
  const { t } = useTranslation("explore");

  return (
    <Box
      sx={{
        height: {
          xs: `calc(100vh - 5vw)`,
          md: `calc(100vh - ${headerHeight} - 50px)`,
        },
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "end",
        pb: { xs: "5vw", md: "50px" },
        backgroundImage: {
          xs: `url(${firstContent?.img_mob})`,
          md: `url(${firstContent?.img})`,
        },
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: { xs: "bottom center", md: "center center" },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        {firstContent?.data.map((it, i) => {
          return (
            <Box
              key={i}
              sx={{
                borderLeft: i === 0 ? "none" : { xs: "", md: "#fff solid 1px" },
                borderTop:
                  i === 0 ? "none" : { xs: "#fff solid 1px", md: "none" },
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "4vw", md: "26px" },
                  fontWeight: 600,
                  fontFamily: "Montserrat",
                  color: "#fff",
                  textAlign: "center",
                  letterSpacing: { xs: 0, md: "auto" },
                  lineHeight: { xs: "4vw", md: "36px" },
                  px: { xs: 0, md: 3 },
                  pt: { xs: "4vw", md: 0 },
                }}
              >
                {createTranslatedOption(it.option, t)} {t(it.type)}
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "4vw", md: "26px" },
                  fontWeight: 600,
                  fontFamily: "Montserrat",
                  color: "#fff",
                  textAlign: "center",
                  letterSpacing: { xs: 0, md: "auto" },
                  lineHeight: { xs: "4vw", md: "36px" },
                  px: { xs: 0, md: 3 },
                  pb: { xs: "4vw", md: 0 },
                }}
              >
                {t(it.description)}
              </Typography>
            </Box>
          );
        })}
        
        {/* Четвертая колонка с кнопкой скачивания PDF - показывается только если pdfFileName существует и не null */}
        {pdfFileName && carId && (
          <DownloadPdfButton 
            pdfFileName={pdfFileName} 
            carId={carId} 
          />
        )}
      </Box>
    </Box>
  );
};

export default FirstContent;
